// nextera

// import URLS from './urls'
import { utils } from 'frontendcommon-3'

const { softColor } = utils.ColorUtils
const brand01 = '#03777B'
const brand02 = '#FC7C66'

export const colors = {
  blackGrey: '#333333',
  darkGrey: '#737373',
  mediumGrey: '#B1B1B1',
  softGrey: '#E2E2E2',
  borderGrey: '#EEEEF0',
  lightGrey: '#FAFAFA',
  brand01,
  brand01Soft: softColor(brand01, 10),
  brand01Medium: softColor(brand01, 50),
  brand01Dark: softColor(brand01, 70),
  brand02,
  brand02Soft: softColor(brand02, 10),
  brand02Medium: softColor(brand02, 50),
  brand02Dark: softColor(brand02, 70),
  brand03: '#003739',
  brand04: '#FFFFFF',
  brand05: '#F3F2E9',
  brand06: '#00CAD4',
  background: '#ffffff',
  sidebarBackground: '#fafafa',
  sidebarBorder: softColor(brand01, 10),
  sidebarFooterBorder: '#fafafa',
  navlinkColor: '#737373',
  navlinkHoverBackground: softColor(brand01, 10),
  error: '#e30513',
  errorLight: '#F9A0B1',
  contrast: '#f9b119',
  offer01: '#ffde17',
  correct: '#75b84e'
}

export const frontendcommonCss = `
:root {
  --fc-black-grey: ${colors.blackGrey};
  --fc-dark-grey: ${colors.darkGrey};
  --fc-medium-grey: ${colors.mediumGrey};
  --fc-soft-grey: ${colors.softGrey};
  --fc-border-grey: ${colors.borderGrey};
  --fc-light-grey: ${colors.lightGrey};
  --fc-brand-01: ${colors.brand01};
  --fc-brand-01-dark: ${colors.brand01Dark};
  --fc-brand-01-medium: ${colors.brand01Medium};
  --fc-brand-01-soft: ${colors.brand01Soft};
  --fc-brand-02: ${colors.brand02};
  --fc-brand-02-dark: ${colors.brand02Dark};
  --fc-brand-02-medium: ${colors.brand02Medium};
  --fc-brand-02-soft: ${colors.brand02Soft};
  --fc-brand-03: ${colors.brand03};
  --fc-brand-04: ${colors.brand04};
  --fc-brand-05: ${colors.brand05};
  --fc-brand-06: ${colors.brand06};
  --fc-background: ${colors.background};
  --fc-sidebar-background: ${colors.sidebarBackground};
  --fc-sidebar-border: ${colors.sidebarBorder};
  --fc-sidebar-footer-border: ${colors.sidebarFooterBorder};
  --fc-navlink-color: ${colors.navlinkColor};
  --fc-navlink-hover-backgound: ${colors.navlinkHoverBackground};
  --fc-error: ${colors.error};
  --fc-error-light: ${colors.errorLight};
  --fc-contrast: ${colors.contrast};
  --fc-offer-01: ${colors.offer01};
  --fc-correct: ${colors.correct};
}
`
export const logo = 'https://nextera-images.imgix.net/logos/nextera-logo-color.png'
// `${URLS.FRONTEND_ASSETS}/logos/nextera_logo.png`
export const logoSmall = 'https://nextera-images.imgix.net/logos/nextera-logo-small-square-trasparent.png'
// `${URLS.FRONTEND_ASSETS}/logos/nextera_logo-small.png`
export const logoColor = 'https://nextera-images.imgix.net/logos/nextera-logo-color.png'
export const logoColorSmall = 'https://nextera-images.imgix.net/logos/nextera-logo-small-square-trasparent.png'
